export function getArtifactDownloadFileName(fileName, kind) {
  const base = fileName?.trim() || 'document'
  if (base.endsWith('.zip')) {
    return base
  }
  if (kind === 'html') {
    return base.endsWith('.html') ? base : `${base}.html`
  }
  if (kind === 'spreadsheet') {
    return base.endsWith('.csv') ? base : `${base}.csv`
  }
  return base.endsWith('.md') ? base : `${base.replace(/\.[^.]+$/, '')}.md`
}
